import { render, staticRenderFns } from "./design-detail-table.vue?vue&type=template&id=501c5738"
import script from "./design-detail-table.vue?vue&type=script&lang=js"
export * from "./design-detail-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports